/**
 * Created by Administrador on 05/11/2018.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('manageReservations', {
                parent: 'app',
                url: '/manageReservation?origin&destiny&stretch&departureDate&page&size',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    origin: "0",
                    destiny: "0",
                    stretch: "0",
                    departureDate: null,
                    page: "0",
                    size: "10"
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/manageReservation/manageReservation.html',
                        controller: 'manageReservationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['manageReservation']);
                            }],
                            airports:['airportService','$stateParams', function(airportService, $stateParams){
                                if ($stateParams.departureDate == null) {
                                    $stateParams.departureDate = (new Date()).getTime();
                                }
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            })
            .state('pnrDelete', {
                parent: 'manageReservations',
                url: '/manageReservation/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/manageReservation/reservationCancel.html',
                        controller: 'reservationCancelCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['manageReservation']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('manageReservations', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
